import TaskListService from '../../../modules/taskList/taskListService'
import Errors from '../../../modules/shared/error/errors'
import { push } from 'redux-first-history'

const prefix = 'TASKLIST_VIEW'

const taskListViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: taskListViewActions.FIND_STARTED,
      })

      const record = await TaskListService.find(id)

      dispatch({
        type: taskListViewActions.FIND_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: taskListViewActions.FIND_ERROR,
      })

      dispatch(push('/task-list'))
    }
  },
}

export default taskListViewActions
